import { useMediaQuery } from "@uidotdev/usehooks"
import { OfferLetterType } from "api/resources/offerLetter/types"
import clsx from "clsx"
import { motion } from "framer-motion"
import { useMemo } from "react"

import PgCTLLogoSpinning from "../PgCTLLogoSpinning"

const TitleBar = ({
  isLgUp,
  isStuck,
  offerLetter,
}: {
  isLgUp?: boolean
  isStuck?: boolean
  offerLetter: OfferLetterType
}) => {
  const canAnimate = !isStuck && isLgUp
  const isSmDown = useMediaQuery("only screen and (max-width : 640px)")
  const titleVariants = useMemo(
    () => ({
      normal: { "font-size": isSmDown ? "28px" : "40px" },
      animate: { "font-size": isSmDown ? "22px" : "24px" },
    }),
    [isSmDown]
  )
  return (
    <div
      className={clsx("top-0 mb-[168px] w-full sm:mb-17", {
        sticky: isLgUp,
      })}
    >
      <div className="relative w-full">
        <motion.div
          animate={{
            boxShadow: canAnimate ? "0px 6px 15px 0px #0000000D" : "none",
          }}
          className="absolute top-0 mb-1 flex w-full flex-col-reverse items-start justify-between bg-white px-2 pb-1 sm:flex-row sm:items-center  sm:px-[38px] sm:pb-0"
        >
          <motion.span
            style={{
              fontFamily: "Inter",
              fontWeight: 700,
              lineHeight: "100%",
              letterSpacing: "-2%",
            }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            variants={titleVariants}
            animate={canAnimate ? ["animate"] : ["normal"]}
          >
            PgCTL Offer Letter
          </motion.span>
          {offerLetter && (
            <motion.div
              animate={{
                width: canAnimate ? 60 : 124,
                height: canAnimate ? 60 : 124,
              }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <PgCTLLogoSpinning slug={offerLetter.product.slug} />
            </motion.div>
          )}
        </motion.div>
      </div>
    </div>
  )
}

export default TitleBar
